module.exports = "<div>\r\n    <i [hidden]=\"params.data.action == 'upload'\" class=\"fa fa-eye\" aria-hidden=\"true\" (click)=\"view()\"></i>\r\n    <i [hidden]=\"params.data.switch == 'Y'\" class=\"fa fa-trash ml-2\" aria-hidden=\"true\" (click)=\"params.data.defaultAction = 'delete'\"></i>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/delete/delete.component.html
// module id = ./src/app/delete/delete.component.html
// module chunks = main